namespace Solovis.Portal.TxServices {

    export class GroupedTxListViewEditModel {

        private _portalServices: Solovis.Portal.IPortalServices;

        private _investmentId;
        private _primaryTransactionEditId;
        private _primaryTransactionEntryId;
        private _originalPrimaryTransactionEntryId;
        private _entries;
        private _groupedTxViewEditModels: GroupedTxViewEditModel[];

        private _modelEnvironment: InvData.ModelEnvironment;
        private _canEdit: boolean;

        public investmentSummaryManager: TxInvestmentSummaryManager;
        public cachedExchangeRateManager: TxCachedExchangeRateManager;
        public cachedPriceManager: TxCachedPriceManager;

        public validationResults;
        private _deletedTransactionIds;
        private _unlinkedTransactionIds;

        private _isDirty;

        constructor(options) {
            const self = this;

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._investmentId = options.investmentId ? options.investmentId : null;
            this._primaryTransactionEditId = options.primaryTransactionEditId ? options.primaryTransactionEditId : null;
            this._primaryTransactionEntryId = options.primaryTransactionEntryId ? options.primaryTransactionEntryId : null;
            this._originalPrimaryTransactionEntryId = options.primaryTransactionEntryId ? options.primaryTransactionEntryId : null;
            this._entries = options.entries ? options.entries : null;
            this._groupedTxViewEditModels = !_.isEmpty(options.groupedTxViewEditModels) ? options.groupedTxViewEditModels : [];

            this._modelEnvironment = options.modelEnvironment ? options.modelEnvironment : null;
            this._canEdit = Solovis.isNotNull(options.canEdit) ? (options.canEdit ? true : false) : true;
            if (this._primaryTransactionEntryId && this._primaryTransactionEditId) {
                this._primaryTransactionEditId = null;
            }
            if (this._entries) {
                $(this._entries).each(function (i, txEntryData) {
                    const groupedTxViewEditModel = self._createEditModelFromEntry(txEntryData);
                    self._groupedTxViewEditModels.push(groupedTxViewEditModel);
                });
            }

            this.investmentSummaryManager = new TxInvestmentSummaryManager({
                portalServices: this._portalServices
            });
            $(options.investmentSummaries).each(function (i, summary: any) {
                self.investmentSummaryManager.registerSummary(summary);
            });

            this.cachedExchangeRateManager = new TxCachedExchangeRateManager({
                portalServices: this._portalServices
            });
            this.cachedPriceManager = new TxCachedPriceManager({
                portalServices: this._portalServices
            });

            // Ensure we do an initial ordering based on primary tx.
            this._orderGroupedTxViewEditModels();
        }


        public portalServices() {
            return this._portalServices;
        }

        public getPropDefIdsToEdit(): number[] {
            const modelEnv = this.modelEnvironment();
            return TxSettings.getCustomPropIdsToEditForModelEnvironment(this._portalServices, modelEnv);
        }


        public _createEditModelFromEntry(txEntryData) {
            const editModelOptions: GroupedTxViewEditModelOptions = {
                groupedTxListViewEditModel: this
            };

            const txModelClone: TxServices.TransactionEntryEditModel = ({} as any);
            for (const propertyName in txEntryData) {
                txModelClone[propertyName] = txEntryData[propertyName];
            }

            editModelOptions.tx = txModelClone;

            const groupedTxViewEditModel = new GroupedTxViewEditModel(editModelOptions);

            return groupedTxViewEditModel;
        }


        public modelEnvironment(modelEnvironment?: InvData.ModelEnvironment): InvData.ModelEnvironment {
            if (!arguments.length) {
                return this._modelEnvironment;
            }
            else {
                this._modelEnvironment = modelEnvironment;
            }
            return null;
        };

        public length() {
            return this._groupedTxViewEditModels.length;
        }

        public investmentId(investmentId?) {
            if (!arguments.length) {
                return this._investmentId;
            }
            else {
                this._investmentId = investmentId;
            }
            return null;
        }

        public primaryTransactionEditId(primaryTransactionEditId?) {
            if (!arguments.length) {
                return this._primaryTransactionEditId;
            }
            else {
                if (Solovis.isNotNull(this._primaryTransactionEntryId)) {
                    console.log("Cannot update edit id when transaction Id exists");
                }
                else {
                    this._primaryTransactionEditId = primaryTransactionEditId;

                    this.notifyModelChanged({
                        operation: "primaryTransactionEditIdChanged",
                        primaryTransactionEditId: this._primaryTransactionEditId
                    });
                }
            }
            return null;
        }

        public primaryTransactionEntryId(primaryTransactionEntryId?) {
            if (!arguments.length) {
                return this._primaryTransactionEntryId;
            }
            else {
                this._primaryTransactionEntryId = primaryTransactionEntryId;
                this._primaryTransactionEditId = null;
                this._orderGroupedTxViewEditModels();

                this.notifyModelChanged({
                    operation: "primaryTransactionEntryIdChanged",
                    primaryTransactionEntryId: this._primaryTransactionEntryId
                });
            }
            return null;
        }

        public groupedTxViewEditModels(groupedTxViewEditModels?: GroupedTxViewEditModel[]): GroupedTxViewEditModel[] {
            if (!arguments.length) {
                return this._groupedTxViewEditModels;
            }
            else {
                this._groupedTxViewEditModels = groupedTxViewEditModels;
                this.notifyModelChanged({
                    operation: "groupedTxViewEditModelsChanged",
                    groupedTxViewEditModels: this._groupedTxViewEditModels
                });
            }
            return null;
        }

        public canEdit(canEdit?) {
            if (!arguments.length) {
                return this._canEdit;
            }
            else {
                this._canEdit = canEdit;
            }
            return null;
        }


        public getTagById(tagId?) {
            if (Solovis.isNull(this._modelEnvironment)) {
                throw "Default tag set is not loaded.";
            }

            const tagSet = this._modelEnvironment.tagSets.tryGetById(GroupedTxViewEditModel.defaultTxTypeTagSetId);
            const foundTag = tagSet.tryGetTagById(tagId);

            if (Solovis.isNull(foundTag)) {
                throw "Tag Id " + tagId + " not found in default tag set.";
            }

            return foundTag;
        }

        public mapEditIdsToTxIds(map) {
            const self = this;

            const groupModel = this.getTransactionGroupModel();
            if (groupModel.success) {
                $(map).each(function () {
                    const mapEntry = this;

                    if (self._groupedTxViewEditModels) {
                        for (const tx of self._groupedTxViewEditModels) {
                            if (tx.editId === mapEntry.editId) {
                                if (tx.editId === groupModel.groupedTxListModel.primaryTx.editId) {
                                    self._primaryTransactionEntryId = mapEntry.txId;
                                    self._primaryTransactionEditId = null;
                                }                                
                                tx.transactionEntryId(mapEntry.txId);
                                delete tx.editId;
                            }
                        }
                    }                   
                });
            }
        }

        public getTransactionGroupModel(): {
            success: boolean;
            groupedTxListModel: TxGroupUpdateModel;
            message?: string
        }{
            this._doValidate();

            const groupedTxListModel: TxGroupUpdateModel = {
                primaryTx: null,
                originalPrimaryTxId: this._originalPrimaryTransactionEntryId,
                secondaryTxList: [],
                txIdsToDelete: []
            };

            const result = {
                success: this.validationResults.isValid,
                groupedTxListModel: groupedTxListModel,
                message: this.validationResults.message
            }

            if (this._groupedTxViewEditModels) {
                for (const groupedTxViewEditModel of this._groupedTxViewEditModels) {
                    if (groupedTxViewEditModel.isPrimary()) {
                        groupedTxListModel.primaryTx = groupedTxViewEditModel.getTransactionDataToSave();
                    }
                    else {
                        groupedTxListModel.secondaryTxList?.push(groupedTxViewEditModel.getTransactionDataToSave());
                    }
                }
            }

            if (!_.isEmpty(this._deletedTransactionIds)) {
                $(this._deletedTransactionIds).each(function () {
                    groupedTxListModel.txIdsToDelete?.push(Number(this));
                });
            }

            if (_.isEmpty(this._groupedTxViewEditModels) && _.isEmpty(this._deletedTransactionIds)) {
                result.success = false;
                result.message = "The transaction group is empty.";
            }

            return result;
        }

        public _doValidate() {
            this.validationResults = {
                isValid: true,
                message: null
            }

            if (Solovis.isNull(this.primaryTransactionEntryId()) &&
                Solovis.isNull(this.primaryTransactionEditId())) {
                this.validationResults.isValid = false;
                this.validationResults.message = "Primary transaction entry is not set.";
            }
            else {
                let missingEffectiveDate = false;
                let missingInvestment = false;

                const txModels = this.groupedTxViewEditModels();
                for (const txModel of txModels) {
                    if (Solovis.isNull(txModel.investmentId())) {
                        missingInvestment = true;
                    }
                    if (Solovis.isNull(txModel.effectiveDayId())) {
                        missingEffectiveDate = true;
                    }
                }

                if (missingEffectiveDate || missingInvestment) {
                    const missingFields = [];                    
                    if (missingEffectiveDate) {
                        missingFields.push("Effective Date");
                    }
                    if (missingInvestment) {
                        missingFields.push("Investment");
                    }
                    let errorMessage = missingFields.join(" and ");
                    errorMessage += " " + ((missingFields.length > 1) ? "are" : "is") + " required for all transactions.";

                    this.validationResults.isValid = false;
                    this.validationResults.message = errorMessage;
                }
            }
        }

        public hasTxWithMissingTxType() {
            const txModels = this.groupedTxViewEditModels();
            for (const txModel of txModels) {
                if (Solovis.isNull(txModel.transactionTypeTagId())) {
                    return true;
                }
            }

            return false;
        }

        public _orderGroupedTxViewEditModels() {
            const tempArray = [];
            let primaryTx = null;
            // The primary transaction always goes first for convenience's sake.

            for (let i = 0; i < this._groupedTxViewEditModels.length; i++) {
                if (this._groupedTxViewEditModels[i].isPrimary()) {
                    primaryTx = this._groupedTxViewEditModels[i];
                }
                else {
                    tempArray.push(this._groupedTxViewEditModels[i]);
                }
            }

            if (Solovis.isNotNull(primaryTx)) {
                tempArray.splice(0, 0, primaryTx);
            }

            // If we are ordering a list after deleting the primary, mark the first one as primary (if it exists).
            else {
                if (this._groupedTxViewEditModels.length > 0) {
                    const txEntryId = this._groupedTxViewEditModels[0].transactionEntryId();
                    if (Solovis.isNotNull(txEntryId)) {
                        this._primaryTransactionEntryId = txEntryId;
                        this._primaryTransactionEditId = null;
                    }
                    else {
                        const txEditId = this._groupedTxViewEditModels[0].editId;
                        this._primaryTransactionEditId = txEditId;
                    }
                }
            }

            this._groupedTxViewEditModels = tempArray;
        }

        public notifyModelChanged(options) {
            this.setIsDirty(true);
            $(this).trigger("modelChange", options);
        }

        public addTransaction(groupedTxViewEditModel, skipValidation: boolean = false) {
            this.setIsDirty(true);

            let validationResults;
            if (!skipValidation) {
                validationResults = groupedTxViewEditModel.validate();
            }

            if (skipValidation || validationResults.isValid) {
                // Check to see if the edit model exists.  if it does, overwrite it.
                if (this.containsEditModel(groupedTxViewEditModel)) {
                    const txIndex = this.indexOf(groupedTxViewEditModel);

                    if (txIndex != -1) {
                        this._groupedTxViewEditModels.splice(txIndex, 1, groupedTxViewEditModel);
                        this.notifyModelChanged({
                            operation: "editTransaction",
                            groupedTxViewEditModel: groupedTxViewEditModel,
                        });
                    }
                    else {
                        throw "GroupedTxViewEditModel index not found.";
                    }
                }
                else {
                    // This is a new model.
                    this._groupedTxViewEditModels.push(groupedTxViewEditModel);
                    this.notifyModelChanged({
                        operation: "addTransaction",
                        groupedTxViewEditModel: groupedTxViewEditModel,
                    });
                }

                // If this is the first Tx added, then it's the primary.
                if (this._groupedTxViewEditModels.length === 1) {
                    const txId = groupedTxViewEditModel.transactionEntryId();
                    if (Solovis.isNotNull(txId)) {
                        this._primaryTransactionEntryId = txId;
                        this._primaryTransactionEditId = null;
                    }
                    else {
                        const txEditId = groupedTxViewEditModel.editId;
                        if (Solovis.isNotNull(txEditId)) {
                            this._primaryTransactionEditId = txEditId;
                        }
                    }
                }
            }
            else {
                console.log("Attempted to add an invalid transaction.  Error message: " + validationResults.errorMessage);
            }
        }

        public indexOf(groupedTxViewEditModel) {
            let txIndex = -1;

            $(this._groupedTxViewEditModels).each(function (index) {
                if (this.equalById(groupedTxViewEditModel)) {
                    txIndex = index;
                }
            });

            return txIndex;
        }

        public containsEditModel(groupedTxViewEditModel) {
            const txEntryId = groupedTxViewEditModel.transactionEntryId();
            const txEditId = groupedTxViewEditModel.editId;
            let found = false;
            if (Solovis.isNotNull(txEntryId)) {
                $(this._groupedTxViewEditModels).each(function () {
                    if (this.transactionEntryId() === txEntryId) {
                        found = true;
                    }
                });
            }
            else if (Solovis.isNotNull(txEditId)) {
                $(this._groupedTxViewEditModels).each(function () {
                    if (this.editId === txEditId) {
                        found = true;
                    }
                });
            }
            return found;
        }

        public deleteTransaction(groupedTxViewEditModel) {
            const txId = groupedTxViewEditModel.transactionEntryId();

            if (txId) {
                if (Solovis.isNull(this._deletedTransactionIds)) {
                    this._deletedTransactionIds = [];
                }
                this._deletedTransactionIds.push(txId);

                this.notifyModelChanged({
                    operation: "deleteTransaction",
                    groupedTxViewEditModel: groupedTxViewEditModel,
                });
            }


            this.unlinkTransaction(groupedTxViewEditModel);
        }


        public unlinkTransaction(groupedTxViewEditModel) {
            this.setIsDirty(true);

            const txIndex = this.indexOf(groupedTxViewEditModel);

            if (txIndex != -1) {
                this._groupedTxViewEditModels.splice(txIndex, 1);

                const txId = groupedTxViewEditModel.transactionEntryId();

                if (txId) {
                    if (Solovis.isNull(this._unlinkedTransactionIds)) {
                        this._unlinkedTransactionIds = [];
                    }
                    this._unlinkedTransactionIds.push(txId);
                }

                this.notifyModelChanged({
                    operation: "unlinkTransaction",
                    groupedTxViewEditModel: groupedTxViewEditModel,
                });
            }
            else {
                console.log("Unexpected: transaction not found.");
            }
        }


        public getTxViewEditModelForPrimaryTransaction(): GroupedTxViewEditModel {
            const txModels = this.groupedTxViewEditModels();

            const primaryTxIndex = _.findIndex(txModels, function (tx: any) {
                return tx.isPrimary();
            });

            if (primaryTxIndex >= 0) {
                return txModels[primaryTxIndex];
            }

            return null;
        }

        public getTxViewEditModelForEditId(editId): GroupedTxViewEditModel {
            let matchedModel = null;

            this._groupedTxViewEditModels.forEach(function (model) {
                if (model.editId == editId) {
                    matchedModel = model;
                }
            });

            return matchedModel;
        }


        public getTxViewEditModelForTransactionEntryId(txEntryId): GroupedTxViewEditModel {
            let matchedModel = null;

            this._groupedTxViewEditModels.forEach(function (model: any) {
                if (model._transactionEntryId == txEntryId) {
                    matchedModel = model;
                }
            });

            return matchedModel;
        }


        public applyTransactionModelUpdates(txModelDataList) {
            const self = this;

            $(txModelDataList).each(function (i, txModelData: any) {
                let txEditModel = null;
                if (txModelData.transactionEntryId) {
                    txEditModel = self.getTxViewEditModelForTransactionEntryId(txModelData.transactionEntryId);
                }
                else if (txModelData.editId) {
                    txEditModel = self.getTxViewEditModelForEditId(txModelData.editId);
                }

                if (txEditModel) {
                    // TODO: Apply changes to tx models (apply other properties).
                    txEditModel._amountIn = txModelData.amountIn;
                    txEditModel._amountOut = txModelData.amountOut;
                }
                else {
                    // New transaction so add it to the model.
                    txEditModel = self._createEditModelFromEntry(txModelData);
                    self._groupedTxViewEditModels.push(txEditModel);
                }
            });

            this.notifyModelChanged({
                operation: "applyTransactionModelUpdates"
            });
        }


        public setIsDirty(isDirty) {
            this._isDirty = isDirty;
        }

        public isDirty() {
            if (this._isDirty) {
                return true;
            }
            else {
                return false;
            }
        }
    }

}